<template>
  <div>
    <div class="tags" v-if="showTags > 0">
      <div v-if="isShow">
        <!-- {{copyList}} -->
        <el-tag
          size="mini"
          class="tags-mini"
          v-for="(item, index) in tagsList"
          :class="{ active: isActive(item.path) }"
          :key="index"
        >
          <router-link :to="item.path" class="tagsTitle">{{ item.title }}</router-link>
          <span
            class="tagsIcon"
            @click="closeTags(index, item.title)"
            v-if="isCance(item.title)"
          >
            <i class="el-icon-close"></i>
          </span>
        </el-tag>
      </div>
      <div class="tags-close-box">
        <el-dropdown @command="handleTags">
          <el-button size="mini" type="primary" plain>
            标签选项<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu size="small" slot="dropdown">
            <el-dropdown-item command="other">关闭其他</el-dropdown-item>
            <el-dropdown-item command="all">关闭所有</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="padding">
      <transition name="fade" mode="out-in">
        <keep-alive :include="keepList">
          <router-view />
        </keep-alive>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      keepList: ["availabilityManage"],
      cancelList: ["首页"],
      tagsList: [{ path: "/home", title: "首页" }],
      copyList: [],
      isShow: true,
      showTags: -1,
      list: [], //主数组
    };
  },
  methods: {
    isActive(path) {
      return path === this.$route.path;
    },
    // 关闭单个标签
    closeTags(index, title) {
      const delItem = this.tagsList.splice(index, 1)[0];
      const item = this.tagsList[index] ? this.tagsList[index] : this.tagsList[index - 1];
      if (title == "直接收银") {
        window.service = "false";
      }
      if (item) {
        delItem.path === this.$route.path && this.$router.push(item.path);
      } else {
        this.$router.push("/home");
      }
    },
    // 关闭全部标签
    closeAll() {
      this.tagsList = [{ path: "/home", title: "首页" }];
      this.$router.push("/home");
    },
    // 关闭其他标签
    closeOther() {
      const curItem = this.tagsList.filter((item) => {
        return item.path === this.$route.path;
      });
      this.tagsList = curItem;
    },
    // 设置标签
    setTags(route) {
      if (route.meta.title == "房源管理" || route.meta.title == "读表数据导入") return;
      if (route.meta.title == "服务单-收银") {
        this.tagsList.forEach((item, index) => {
          if (item.title == "服务单-收银") {
            this.tagsList.splice(index, 1, {
              title: route.meta.title,
              path: route.path,
            });
          }
        });
      }
      this.isShow = false;
      const isExist = this.tagsList.some((item) => {
        return item.title === route.meta.title;
      });
      //isExist false:不存在 需要添加 true:存在 需要切换
      if (!isExist) {
        if (this.tagsList.length > 8) {
          this.tagsList.pop();
          this.tagsList.push({
            title: route.meta.title,
            path: route.path,
          });
        } else {
          this.tagsList.push({
            title: route.meta.title,
            path: route.path,
          });
        }
      }
      setTimeout(() => {
        this.showTags = this.tagsList.length;
      }, 100);
      this.copyList = JSON.parse(JSON.stringify(this.tagsList));
      this.isShow = true;

      if (route.meta.title != "促销购买") {
        this.tagsList.forEach((item, index) => {
          if (item.title == "促销购买") {
            console.log(index);
            this.tagsList.splice(index, 1);
          }
        });
      }
      if (!sessionStorage.getItem("list") && route.path != "/login") {
        this.$message.error({
          message: "没有操作权限!",
        });
        setTimeout(() => {
          this.$router.push("/");
          sessionStorage.clear();
          localStorage.clear();
        }, 2000);
      }
    },
    handleTags(command) {
      command === "other" ? this.closeOther() : this.closeAll();
    },
  },
  computed: {
    isCance() {
      return function (val) {
        let index = this.cancelList.findIndex((item) => item === val);
        if (index == -1) {
          return true;
        } else {
          return false;
        }
      };
    },
  },
  watch: {
    $route(newValue, oldValue) {
      setTimeout(() => {
        this.setTags(newValue);
        return;
      }, 100);
    },
  },
  created() {
    let list = JSON.parse(sessionStorage.getItem("list"));
    // let index1 = list.findIndex(item=>item.id == '500200') //收银
    // let index2 = list.findIndex(item=>item.id == '500400') //疗程
    // let index3 = list.findIndex(item=>item.id == '500300') //充值
    // if(index3 != -1){
    //   this.tagsList.push({ path: "/collectionList", title: "充值" })
    // }
    // if(index2 != -1){
    //   this.tagsList.push({ path: "/reatment", title: "疗程" })
    // }
    // if(index1 != -1){
    //   this.tagsList.push({ path: "/services", title: "直接收银" },)
    // }
    this.setTags(this.$route);
    // 监听关闭当前页面的标签页
  },
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.6s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.padding {
  padding: 10px 10px 0 10px;
  box-sizing: border-box;
}
.tags {
  overflow: hidden;
  padding-left: 20px;
  display: flex;
  justify-content: space-between;
  border: 1px solid #eef8ff;
  background: #cbe9ff;
  position: sticky;
  top: 0;
  padding-top: 5px;
  padding-bottom: 5px;
  z-index: 99;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  margin: 0px 5px;
}
.tags-mini {
  font-size: 12px;
  overflow: hidden;
  cursor: pointer;
  height: 25px;
  line-height: 25px;
  padding-left: 13px;
  padding-right: 10px;
  border-radius: 4px;
  margin-right: 5px;
}
.tags .el-dropdown {
  margin-right: 10px;
}
.tags-mini:not(.active):hover {
  background: linear-gradient(#237fe0, #5facfd) !important;
  color: white;
}
.tags-mini.active {
  color: black;
  background: linear-gradient(#237fe0, #5facfd) !important;
}

.tagsTitle {
  float: left;
  max-width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 4px;
  color: white;
  text-decoration: none;
  font-family: "宋体";
}
.tags-mini.active .tagsTitle {
  color: #fff;
}
.el-button--primary:focus,
.el-button--primary:hover {
  background: linear-gradient(#1873d4, #51a5ff);
}

.el-dropdown-menu__item:hover {
  background: linear-gradient(#1873d4, #51a5ff) !important;

  color: #ffffff !important;
}
.tags-mini {
  background: #71b6ff;

  color: white;
}
.tags-close-box {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Emain.vue